<p class="control-title"><strong>Access required</strong></p>
<div [class.dropdown-disabled-wrapper]="disabled()">
    <ng-multiselect-dropdown
      [placeholder]="'Search by office locations'"
      [data]="availableLocations"
      [(ngModel)]="selectedAccessRequired"
      [settings]="dropdownSettings"
      (onSelect)="onSelectionChange($event)"
      (onDeSelect)="onSelectionChange($event)"
      (onSelectAll)="onSelectAll($event)"
      (onDeSelectAll)="onDeSelectAll($event)">
    </ng-multiselect-dropdown>
</div>